import { Breadcrumb, Button, Pagination, Result } from 'antd';
import React, { useState, useEffect } from 'react';
import Filters from './Filters';
import './Cars.scss';
import { CarsList } from '../../dummy/dummy';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import CarModal from '../../components/CarModal/CarModal';
import Api from '../../network/ApiConfig';
import CarCard from './CarCard';
import { handelGetParamsFromUrl } from '../../helpers/helpers';

export default function Cars({ location }) {
  const [detailsModal, setDetailsModal] = useState(false);
  const [CarSearchLoading, setCarSearchLoading] = useState(false);
  const [CarSearchList, setCarSearchList] = useState([]);
  const query = new URLSearchParams(location?.search);
  const CarBrandName = query?.get('CarBrandName');
  console.log(detailsModal, 'detailsModal in search');
  useEffect(() => {
    handelGetSearchData();
  }, [location?.search]);

  // const handelGetParamsFromUrl = (query) => {
  //   console.log(location, 'location');
  //   const CarBrandId = query?.get('CarBrandId');
  //   const CarModelId = query?.get('CarModelId');
  //   const GearTypeId = query?.get('GearTypeId');
  //   const CarFuelTypeId = query?.get('CarFuelTypeId');
  //   const CarShapeId = query?.get('CarShapeId');
  //   const FromPrice = query?.get('FromPrice');
  //   const ToPrice = query?.get('ToPrice');
  //   const ProductionYearFrom = query?.get('ProductionYearFrom');
  //   const ProductionYearTo = query?.get('ProductionYearTo');
  //   const body = {
  //     CarBrandId,
  //     CarModelId,
  //     FromPrice,
  //     ToPrice,
  //     GearTypeId,
  //     CarFuelTypeId,
  //     ProductionYearFrom,
  //     ProductionYearTo,
  //     CarShapeId,
  //   };
  //   return body;
  // };

  const handelGetSearchData = (pageIndex) => {
    const body = handelGetParamsFromUrl(query, location);
    if (pageIndex) {
      body.Page = pageIndex - 1;
    }
    setCarSearchLoading(true);
    Api.post('CarModels/Search', body).then(
      (res) => {
        setCarSearchLoading(false);
        if (res?.status === 200) {
          setCarSearchList(res?.data?.model || []);
        }
        // setCarSearch();
      },
      (err) => {
        setCarSearchLoading(false);
        // console.log(err, "errrrrrrrrrrrrrrrrrrrrrrrrrrr")
      }
    );
  };

  // const handleFilterRequest = (body) => {
  //   setCarSearchLoading(true);
  //   Api.post('/CarModels/FilterRequest', body).then(
  //     (res) => {
  //       setCarSearchLoading(false);
  //       if (res?.status === 200) {
  //         console.log(res?.data, 'res?.data');
  //         setCarSearchList(res?.data?.model || []);
  //       }
  //       // setCarSearch();
  //     },
  //     (err) => {
  //       setCarSearchLoading(false);
  //       // console.log(err, "errrrrrrrrrrrrrrrrrrrrrrrrrrr")
  //     }
  //   );
  // };

  return (
    <div className='cars-wrapper'>
      <div className='container'>
        <Breadcrumb separator='>'>
          <Breadcrumb.Item>
            <Link to='/home'>
              <HomeOutlined />
              <p className='link-name'>الرئيسية</p>
            </Link>
          </Breadcrumb.Item>
          {CarBrandName && (
            <Breadcrumb.Item className='last-bread'>
              {CarBrandName}
            </Breadcrumb.Item>
          )}
        </Breadcrumb>
        <CarModal
          mainData={detailsModal}
          open={detailsModal}
          setOpen={setDetailsModal}
        />

        <div className='cars-content-holder'>
          <div className='cars-filter-holder'>
            <Filters location={location} />
          </div>
          <div className='cars-search-holder'>
            {/* <div className="search-category-wrapper">
              <div className="cars-search-category-list">
                {[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]?.map((ele) => (
                  <Link to="/cars" className="category-card-holder">
                    <img
                      src="https://cdn.syarah.com/syarah/bundles/carLogos/38.png"
                      alt=""
                    />
                    <p>44 سياره</p>
                  </Link>
                ))}
              </div>
            </div> */}
            <div className='cars-search-grid'>
              {(CarSearchLoading
                ? { Data: [1, 2, 3, 4, 5, 6] }
                : CarSearchList
              )?.Data?.map((car) => (
                <CarCard
                  CarSearchLoading={CarSearchLoading}
                  setDetailsModal={setDetailsModal}
                  car={car}
                />
              ))}
            </div>
            {!CarSearchLoading && !CarSearchList?.Data?.length && (
              <Result status={404} title='لا يوجد سيارات' />
            )}
          </div>
        </div>
        <div className='pagination-card-holder'>
          <Pagination
            className=''
            onChange={(page) => handelGetSearchData(page)}
            total={CarSearchList?.TotalPages}
            pageSize={20}
            hideOnSinglePage
            responsive
          />
        </div>
      </div>
    </div>
  );
}
